/* import __COLOCATED_TEMPLATE__ from './sq-input-number.hbs.js'; */
var _dec, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { isNone } from '@ember/utils';
import { convertFromFullwidth } from '@square/dashboard-translations/utils/halfwidth-fullwidth-converter';
import SqInputFormattedComponent from './sq-input-formatted';
let SqInputNumber = (_dec = computed('invalidClass', 'isInvalid'), _class = class SqInputNumber extends SqInputFormattedComponent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "formatter", _descriptor, this);
    _defineProperty(this, "_isInvalid", '');
  }
  get _internalIsInvalid() {
    if (this.isInvalid) {
      return this.invalidClass;
    }
    return undefined;
  }
  _getFormatter() {
    let numberFormatter = this.formatter.buildNumberFormatter();
    numberFormatter.isChangeValid = function (change) {
      // if the current text is 0 replace the proposed text with the inserted text
      let proposedText = change.proposed.text;
      if (change.current.text === '0') {
        proposedText = change.inserted.text;
      }
      proposedText = convertFromFullwidth(proposedText);

      // allow field state '-' for ONCALL-11261
      // TODO(wmcc+bjm): generalize this function
      return proposedText === '-' || this.format(proposedText) === proposedText;
    };
    if (!isNone(this.maxLength)) {
      numberFormatter = numberFormatter.setMaximumIntegerDigits(Number.parseInt(this.maxLength, 10));
    }
    if (!isNone(this.minValue)) {
      numberFormatter = numberFormatter.setMinimum(Number(this.minValue));
    }
    if (!isNone(this.maxValue)) {
      numberFormatter = numberFormatter.setMaximum(Number(this.maxValue));
    }
    return numberFormatter;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "_internalIsInvalid", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "_internalIsInvalid"), _class.prototype), _class);
export { SqInputNumber as default };